import Chart, { Element } from 'chart.js/auto'
import { GLOBAL_COLORS, colors } from 'theme'

export const tooltipLine = (
  isDarkMode: boolean,
): { id: string; afterDraw: (chart: Chart) => void } => {
  return {
    id: 'tooltipLine',
    afterDraw: (chart: Chart): void => {
      const ctx = chart.ctx
      ctx.save()
      const activePoints: Element[] | undefined = chart?.tooltip
        ?.getActiveElements()
        .map((el) => el.element)
      if (!activePoints) return
      activePoints.map((el) => {
        ctx.lineWidth = 2
        ctx.strokeStyle = colors(isDarkMode).text1
        ctx.beginPath()
        ctx.arc(el?.x || 0, el?.y || 0, 4, 0, 2 * Math.PI)
        ctx.fillStyle = colors(!isDarkMode).seashellWhiteToDeepOceanBlue
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
        ctx.beginPath()
        ctx.moveTo(el?.x || 0, chart.chartArea.bottom)
        ctx.lineTo(el?.x || 0, el?.y + 4 || 0)
        ctx.lineWidth = 1
        const lineGradient = ctx.createLinearGradient(0, 0, 0, 400)
        if (isDarkMode) {
          lineGradient.addColorStop(0, GLOBAL_COLORS.white)
          lineGradient.addColorStop(0.9, GLOBAL_COLORS.transparent)
          lineGradient.addColorStop(1, GLOBAL_COLORS.transparent)
        } else {
          lineGradient.addColorStop(0, GLOBAL_COLORS.deepOceanBlue05)
          lineGradient.addColorStop(0.7, GLOBAL_COLORS.transparent)
          lineGradient.addColorStop(1, GLOBAL_COLORS.transparent)
        }
        ctx.strokeStyle = lineGradient
        ctx.stroke()
        ctx.closePath()
      })
    },
  }
}
